<template>
    <div>
        <button class="btn btn-success btn-block" @click="btnClicked">ایجاد سند حسابداری</button>
    </div>
</template>

<script>
import EventBus from "../_framework/bus.js";
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  name: "open-accounting-document-button",
  props: ["header", "row"],
  methods: {
    btnClicked() {
      this.$store.commit("REMOVE_ALL_ROWS_FROM_VS_TABLE_FEED");
      this.$router.push({ name: "سند حسابداری", params: { mode: "create" } });
    }
  },
  computed: {
    ...mapState(["vsTableFeed"])
  }
};
</script>

<style scoped>
</style>